/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ files: NonNullable<unknown> }} Toast_File_Too_LargeInputs */

const en_toast_file_too_large = /** @type {(inputs: Toast_File_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File too large: ${i?.files}. Maximum file size is 300MB.`)
};

const nl_toast_file_too_large = /** @type {(inputs: Toast_File_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestand te groot: ${i?.files}. Maximale bestandsgrootte is 300MB.`)
};

/**
* | output |
* | --- |
* | "File too large: {files}. Maximum file size is 300MB." |
*
* @param {Toast_File_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_file_too_large = /** @type {((inputs: Toast_File_Too_LargeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_File_Too_LargeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_file_too_large(inputs)
	return en_toast_file_too_large(inputs)
});